import React from "react";
import {
  Typography,
  Card,
  Descriptions,
  Space,
  Tag,
  Divider,
  Row,
  Col,
  Badge,
} from "antd";
import {
  SafetyCertificateOutlined,
  HomeOutlined,
  UserOutlined,
  CheckCircleOutlined,
  InfoCircleOutlined,
  PhoneOutlined,
  MailOutlined,
  NumberOutlined,
  FileOutlined,
} from "@ant-design/icons";
import AdminPageLayout from "./layout/AdminPageLayout";

const { Title, Paragraph, Text } = Typography;

const Certificati = () => {
  return (
    <AdminPageLayout
      title="Certificati"
      icon={<SafetyCertificateOutlined />}
      subtitle="Certificazioni e documenti ufficiali"
    >
      <Card 
        title={
          <Space>
            <SafetyCertificateOutlined />
            <span>Certificato di Rilascio del Codice Identificativo Nazionale (CIN)</span>
          </Space>
        }
        bordered={true}
        style={{ marginBottom: 24 }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Paragraph>
            <Text strong style={{ fontSize: 16 }}>Nome Cognome:</Text> Francesco De Campo<br />
            <Text strong style={{ fontSize: 16 }}>Codice Fiscale (CF):</Text> DCMFNC92M22L175D
          </Paragraph>
          
          <Paragraph>
            Ha richiesto e ottenuto il rilascio del Codice Identificativo Nazionale (CIN) in conformità alle leggi vigenti.
          </Paragraph>

          <Divider orientation="left">
            <Space>
              <HomeOutlined />
              <span>Dati della Struttura</span>
            </Space>
          </Divider>
          
          <Descriptions bordered column={{ xxl: 4, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }}>
            <Descriptions.Item label="Denominazione">Appartamento De Campo Francesco</Descriptions.Item>
            <Descriptions.Item label="E-mail"><MailOutlined /> decampo.francesco@gmail.com</Descriptions.Item>
            <Descriptions.Item label="Telefono"><PhoneOutlined /> 3898393810</Descriptions.Item>
            <Descriptions.Item label="Numero posti letto"><NumberOutlined /> 3</Descriptions.Item>
            <Descriptions.Item label="Numero camere"><NumberOutlined /> 1</Descriptions.Item>
            <Descriptions.Item label="CIN">
              <Tag color="blue" style={{ fontWeight: 'bold', fontSize: '14px' }}>IT014066C2J9ADOT5C</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Categoria">Alloggi privati in affitto in forma non imprenditoriale</Descriptions.Item>
            <Descriptions.Item label="Classificazione">C2 - Altri alloggi privati</Descriptions.Item>
            <Descriptions.Item label="Regione">Lombardia</Descriptions.Item>
            <Descriptions.Item label="Provincia">Sondrio</Descriptions.Item>
            <Descriptions.Item label="Comune">Tirano</Descriptions.Item>
          </Descriptions>
          
          <Divider orientation="left">
            <Space>
              <HomeOutlined />
              <span>Indirizzo della Struttura</span>
            </Space>
          </Divider>
          
          <Descriptions bordered column={{ xxl: 3, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}>
            <Descriptions.Item label="CAP">23037</Descriptions.Item>
            <Descriptions.Item label="Via">Pier Angelo Lavizzari, n. 10, Piano S1-1</Descriptions.Item>
            <Descriptions.Item label="Categoria catastale">C/1 (Negozi e botteghe)</Descriptions.Item>
            <Descriptions.Item label="Foglio/Particella/Subalterno">35 / 1039 / 31</Descriptions.Item>
          </Descriptions>
          
          <Divider orientation="left">
            <Space>
              <UserOutlined />
              <span>Dati del Dichiarante (Titolare/Gestore)</span>
            </Space>
          </Divider>
          
          <Descriptions bordered column={{ xxl: 3, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }}>
            <Descriptions.Item label="Nome">Francesco De Campo</Descriptions.Item>
            <Descriptions.Item label="E-mail"><MailOutlined /> decampo.francesco@gmail.com</Descriptions.Item>
            <Descriptions.Item label="Telefono"><PhoneOutlined /> 3898393810</Descriptions.Item>
            <Descriptions.Item label="Codice Fiscale">DCMFNC92M22L175D</Descriptions.Item>
            <Descriptions.Item label="Ruolo">Titolare</Descriptions.Item>
            <Descriptions.Item label="Tipo persona">Fisica</Descriptions.Item>
          </Descriptions>
          
          <Divider orientation="left">
            <Space>
              <FileOutlined />
              <span>Dichiarazioni</span>
            </Space>
          </Divider>
          
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Badge status="success" text={
                <Text>
                  <CheckCircleOutlined style={{ color: '#52c41a' }} /> L'unità immobiliare è dotata di estintori portatili a norma di legge.
                </Text>
              } />
            </Col>
            <Col span={24}>
              <Badge status="success" text={
                <Text>
                  <CheckCircleOutlined style={{ color: '#52c41a' }} /> L'unità immobiliare è dotata di dispositivi per la rilevazione di gas combustibili e monossido di carbonio funzionanti.
                </Text>
              } />
            </Col>
          </Row>
          
          <Divider style={{ margin: '24px 0 8px' }} />
          
          <Text type="secondary" style={{ display: 'block', textAlign: 'right' }}>
            <InfoCircleOutlined /> Data ultimo aggiornamento: 21/02/2025 13:38
          </Text>
        </Space>
      </Card>
    </AdminPageLayout>
  );
};

export default Certificati;
